/**
 * mwApp.common module <br>
 * Contains sidebar, header, common services, etc
 *
 * @namespace mwApp/common
 */

/**
 * ConfigRoutes
 * Configurates application routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc config
 * @name mwApp/common.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider, $urlServiceProvider, $locationProvider, $injectorProvider, stConfig) {
  $stateProvider

    /**
     * controller {@link mwApp/home.controller:DashboardCtrl} or {@link mwApp/auth.controller:LoginCtrl}
     * @name /
     * @memberof mwApp/common.config:ConfigRoutes
     */
    .state('app', {
      url: '',
      views: {
        '': {
          //   template: '<ui-view/>'
          templateUrl: 'components/common/views/wrapper.html',
          controller: 'WrapperCtrl as vm'
        },
        'Ai_Chat@app': {
          templateUrl: 'components/common/components/aiChat/aiChat.html',
          controller: 'AiChatController as vm'
        },
        header: {
          templateUrl: 'components/common/views/header.html',
          controller: 'HeaderCtrl as vm'
        },
        sidebar: {
          templateUrl: 'components/common/views/sidebar.html'
        },
        maintenance: {
          templateUrl: 'components/common/views/maintenance.html',
          controller: 'MaintenanceCtrl as vm'
        }
      }
    })

    /**
     * 404 page
     * @name /404
     * @memberof mwApp/common.config:ConfigRoutes
     */
    .state('app.404', {
      url: '/404?{message:any}',
      templateUrl: 'components/common/views/404.html',
      controller: 'Error404Ctrl as vm',
      access: '' // == 'authenticated', means user should be authenticated
    })

    /**
     * 403 page
     * @name /403
     * @memberof mwApp/common.config:ConfigRoutes
     */
    .state('app.403', {
      url: '/403',
      templateUrl: 'components/common/views/403.html',
      access: '' // == 'authenticated', means user should be authenticated
    })

    /**
     * 403 page
     * @name /403
     * @memberof mwApp/common.config:ConfigRoutes
     */
    .state('app.403su', {
      url: '/setplex-user-403',
      templateUrl: 'components/common/views/403su.html',
      controller: 'Error403suCtrl as vm'
    })

  // show 404 error on wrong URLs
  $urlServiceProvider.rules.otherwise((matchValue, url, router) => {
    const authSvc = $injectorProvider.$get().get('authSvc')
    const isAuthenticated = authSvc.isAuthenticated()
    router.stateService.go(
      isAuthenticated ? 'app.404' : 'login',
      !isAuthenticated ? { go: url.path } : undefined
    )
  })

  $urlServiceProvider.config.strictMode(false)
  $locationProvider.html5Mode(true)

  // SmartTable global configuration
  // https://github.com/lorenzofox3/Smart-Table/blob/master/src/stConfig.js
  stConfig.pagination.template = 'components/common/templates/stPagination.html'
  stConfig.pagination.itemsByPage = 25
  stConfig.sort.delay = 100
  stConfig.pipe.delay = 200
}
